import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            为什么选择茄子视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            我们致力于为您提供最好的<strong>视频网站</strong>导航服务，<strong>不缓冲</strong>流畅观影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/60"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl bg-accent-100">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}